const Form104TC = {
    stepName: {
        importantNotes: "重要提示",
        partA: "學校基本資料",
        partB: "學校背景資料",
        partC: "聲明",
        confirmation: "確認",
    },
    importantNotesContent: {
        statement: "本人已閱讀、明白及同意上述條款及細則。",
        termsConditions: "本人理解申請人需要擁有「智方便+」帳戶才能處理申請。",
    },

    note: {
        partB: "[<i>資料請由學校校監根據學校於<b><u>{{snapshot}}</u></b>的情況<b><u>核實及提供</u></b>，並於<b><u>丙部聲明</u></b>所載內容均屬真確無訛。教育局不保證資料準確，亦不會負責因資料錯漏而導致的損失。</i>]",
        schoolEmail:
            "請提供一個電郵地址作為電子聯絡方式，以便本局日後可就此學校資料表格與學校聯絡。",
        certificateNote1:
            "香港中學會考五科成績達E級或第2等級或以上，包括英國語文[在二零零七年前的英國語文(課程乙)]或中國語文，並須在不多於兩次考試中獲取。",
        certificateNote2: `香港中學文憑考試五科達到指定成績，包括英國語文或中國語文成績達第2級，以及以下任何組合：`,
        certificateNote3: "新高中科目成績達第2級；",
        certificateNote4: "應用學習科目（最多計算兩科）成績為“達標”；以及",
        certificateNote5: "其他語言科目成績達E級",
        certificateNote6: "並須在不多於兩次考試中獲取。",
    },

    label: {
        scrn: "學校編號",
        schoolNumber: "學校編號",
        principalOrSupervisor: "閣下的職位",
        district: "學校所在分區",
        schoolName: "學校名稱",
        registeredSchoolPremises: "註冊校址",
        schoolEmail: "學校電郵地址",
        schoolTelephone: "學校電話號碼",
        schoolFax: "學校傳真號碼",
        schoolWebsite: "學校網址",
        supervisorTitle: "校監稱謂",
        supervisorSurname: "校監姓氏",
        supervisorGivenName: "校監名字",
        principalTitle: "校長稱謂",
        principalSurname: "校長姓氏",
        principalGivenName: "校長名字",
        schoolFacilities: "學校設施 (例如: 註冊課室以外的電腦室、圖書館)",
        teacherInformation: "教員資料",
        fulltimeTeachers: "(i) 全職教員人數",
        parttimeTeachers: "(ii) 兼職教員人數",
        teachersHighestQualifications: "(iii) 教員取得的最高學歷",
        qualifications: "學歷",
        postgraduateDegrees: "學士學位以上",
        bachelorDegrees: "學士學位",
        diplomasOrCertificates: `專上<br>文憑/證書`,
        certificateText1:
            "香港中學會考證書 <span style='font-size: 10px'>註(1)</span>",
        certificateText2: "或",
        certificateText3:
            "香港中學文憑考試證書 <span style='font-size: 10px'>註(2)</span>",
        grandTotal: "總計",
        trainedTeachersNo:
            "曾受師資訓練教員的人數（持有教育文憑/證書/學位或教師證書）",
        untrainedTeachersNo: "未受師資訓練教員的人數",
        teacherInformationRemark:
            "備註 : (a)+(b) 及(c)+(d) 的教員人數應該相同。",
        insurancePolicy:
            "截至{{insurancePolicyStartDate}}的保險計劃 （例如：公眾責任）",
        insuranceType: "保險類別",
        insuranceCompany: "保險公司",
        policyNumber: "保單編號",
        expiryDate: "屆滿日期",
        declaration: "聲明",
        schoolInformationCheck1: "本人證明本表格內所有內容均屬真確無訛。本人*",
        schoolInformationCheck2:
            "上述學校資料（校監姓名及校長姓名除外）上載於教育局網頁內，以供公眾參考。",
        supervisorPersonalParticularsCheck1: "本人*",
        supervisorPersonalParticularsCheck2:
            "在教育局網頁內披露校監姓名予公眾人士。",
        principalPersonalParticularsCheck1: "本人*",
        principalPersonalParticularsCheck2:
            "在教育局網頁內披露校長姓名予公眾人士。",
        schoolChop: "學校印鑑",
        filledBySchoolHead: "由校長填寫",
        filledBySchoolSupervisor: "由校監填寫",
        appliantRole: "申請人角色",
        schoolHeadApplicationStatus: "是否本局已批准校長聘任的申請？",
        supervisorApplicationStatus: "是否本局已批准你出任上述學校校監？",
        notProvided: "沒有提供",
        note: "註",
    },
    errorMsg: {
        totalNumberSame: "(a)+(b) 及(c)+(d) 的教員人數應該相同。",
        expiryDate: "保單已過期。",
        fulltimeTeachers: "若無全職教師請輸入「0」。",
        parttimeTeachers: "若無兼職教師請輸入「0」。",
        schoolNumber: "這並不是一個有效的非正規私校的學校編號。",
        appliantRole: "請選擇要退回的角色。",
        alreadySubmitted: "學校已提交今年的表格。",
        consistentName: "姓氏與名字所用的語言應一致。",
        tel: "請不要輸入相同的電話號碼。",
        telRule: "請輸入一個有效的電話號碼。",
        required: "此項必須填寫。",
        maxTextLength: "此項最多只能填寫{{max}}個字。",
        validWithName: "請輸入一個有效的{{fieldName}}。",
        faxRule: "請輸入一個有效的傳真號碼。",
        accessRequiredFile: "請上傳{{fieldName}}。",
        number: {
            max: "此項最大值為{{max}}。",
            integer: "此項必須為整數。",
        },
        text: {
            invalid: "請輸入一個有效的{{fieldName}}。",
        },
        email: {
            rule: "請輸入一個有效的電郵地址。",
        },
    },

    option: {
        principalOrSupervisor: {
            principal: "校長",
            supervisor: "校監",
            principalAndSupervisor: "校長和校監",
        },
        supervisorApplicationStatus: {
            approved: "申請已獲批准",
            inProcess: "正在申請",
        },
        principalApplicationStatus: {
            approved: "申請已獲批准",
            inProcess: "正在申請",
            exempted: "委任獲豁免",
        },
        title: {
            Mr: "先生",
            Ms: "女士",
            Miss: "小姐",
            Br: "修士",
            Dr: "博士",
            Fr: "神父",
            Rev: "牧師",
            Sr: "修女",
            Ven: "法師",
        },
        declaration: {
            yes: "同意",
            no: "不同意",
        },
    },
    dialog: {
        title: "注意",
        content:
            "請列印已填妥的表格及人手簽署，並將簽妥的表格郵寄至教育局學校註冊及監察組(辦事處地址：香港柴灣利眾街24號東貿廣場28樓2810室），傳真至傳真號碼：2123 1276，或電郵至cct@edb.gov.hk。",
    },
    signature: {
        applicant: "這張表格已被 <b>{{name}} {{post}}</b> 簽署並提交。",
        approver: "這張表格已被 <b>{{name}} {{post}}</b>  簽署並提交。",
        secApprover: "這張表格已被 <b>{{name}} {{post}}</b>  簽署並提交。",
        reviewer: "這張表格已被 <b>{{name}} {{post}}</b> 通過並簽署。",
    },
    mode: {
        edbEdit: "注意：這張表格正在等待EDB接受。",
    },
    button: {
        edbSubmit: "接受",
    },
    reply: {
        haveReturnReminder: "你想給填表者附上信息嗎？",
    },
};

export default Form104TC;
